import type { IAssessmentClientItem, IAssessmentClientState, IAssessmentResult } from '../types';

export function createAssessmentClientState<
  TItem extends IAssessmentClientItem = IAssessmentClientItem,
  TResult = IAssessmentResult,
>(totalCount: number): IAssessmentClientState<TItem, TResult> {
  if (!Number.isInteger(totalCount) || totalCount <= 0) {
    throw new Error('Assessment total count must be a positive integer');
  }
  return {
    answeredCount: 0,
    attemptId: null,
    currentItem: null,
    currentToken: null,
    error: null,
    phase: 'idle',
    result: null,
    totalCount,
  };
}
